import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/common/Button";
import styles from "./LoginScreen.module.css";

export function LoginScreen() {
  const { login } = useAuth();
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <img src="/logo-banner.png" alt="A Beekeepers Chronicle" style={{ maxWidth: "100%", width: 320 }} />
        <h1>Admin</h1>
        <p>Internal operations console -- sign in with your admin account.</p>
        <Button onClick={login}>Sign In</Button>
        <p className={styles.notice}>
          This app is restricted to authorized administrators. Every sign-in and action is logged.
        </p>
      </div>
    </div>
  );
}
